import { render } from "./HeroiconsOutlineUserRemove.vue?vue&type=template&id=ea7cb518"
const script = {}

import exportComponent from "/Users/valdisaglonietis/PhpstormProjects/news_site/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineUserRemove.vue"]])

export default __exports__